import React, { Fragment } from 'react'

const FAQBanner = () => {
    return (
        <Fragment>
            <div className="container faqbanner homemenu">
                <div className="row">
                    <div className="col-sm-12">
                        <h2>FAQs</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default FAQBanner
